<template>
    <base-modal ref="baseModal" @resetform="resetForm()" :load-data="loadData" :send="send" :valid-form="isValid">
        <template v-slot:header>
            <h3>{{$t('sendSMS_title')}}</h3>
        </template>
        <div class="row">
                <div class="col-xs-12  form-group">
                    <label for="name" translate>{{$t('sms_template_text')}}:</label>
                    <select class='form-control' v-model="formData.templateid">
                        <option v-for="item in templates" v-bind:value="item.id" v-bind:key="item.id">{{item.name}}</option>
                    </select>
                </div>
                <div v-if="template">
                    <div v-if="template.from" class="col-xs-12 form-group">
                        <label for="from" translate>{{$t('from_text')}}:</label>
                        <input disabled class='form-control' name="number" :value="template.from">
                    </div>
                    <div class="col-xs-12 form-group">
                        <label for="number" translate>{{$t('number_title')}}:</label>
                        <div ng-class="{ 'has-error' : custForm.number.$invalid && custForm.number.$touched,'has-success' : custForm.number.$valid}">
                            <ValidationProvider name="number" rules="required|mobilephone">
                                <div slot-scope="{ errors }">
                                    <input class='form-control' name="number" v-model="formData.number">
                                    <p style="color:red" role="alert">{{ errors[0] }}</p>
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div v-if="template.msg" class="col-xs-12 form-group">
                        <label for="from" translate>{{$t('message_title')}}:</label>
                        <textarea disabled rows="4" cols="60" style="display: block" v-model="template.msg" />
                    </div>
                </div>
        </div>
    </base-modal>

</template>

<script>
import BaseModal from "./BaseModal";
import "../vee-validate";

export default {
	props: ["agentService"],
	data: () => ({formData: {templateid: null}, templates: null}),
	components: {BaseModal},
	methods: {
		open() {
			this.$refs.baseModal.open();
		},
		async loadData() {
			this.templates = await this.getTemplates();
		},
		getTemplates() {
			return this.agentService.getSMS().then(res => {
				return res.data;
			});
		},
		resetForm() {
			this.formData = {templateid: null};
		},
		async send(bvModalEvt) {
			return this.agentService.sendSMS({
				from: this.template.from,
				msg: this.template.msg,
				number: this.formData.number
			}).then(res => {
				return res == "ok" ? "ok" : false;
			});
		}
	},
	computed: {
		template() {
			let selectedTemplateId = this.formData.templateid;
			if (!this.templates) {
				return null;
			}
			return this.templates.find(template => {
				return template.id === selectedTemplateId;
			});
		},
		isValid() {
			return !!this.template;
		}
	}
};
</script>